import { TextField } from '@material-ui/core';
import React from 'react';
import AdminMaterialInput from './AdminMaterialInput';


export default (props) => (
  <AdminMaterialInput component={TextField} {...props} />
);
